import { selectPiece, movePiece, clearHighlights, checkForPromotion, checkForWin, changeTurn, updateMoveHistory, validateMove } from "../engine/GameEngine";

export const ACTIONS = {
    INITIALIZE_GAME: 'INITIALIZE_GAME',
    SELECT_PIECE: 'SELECT_PIECE',
    MOVE_PIECE: 'MOVE_PIECE',
    CAPTURE_MOVE_PIECE: 'CAPTURE_MOVE_PIECE',
    UNDO_MOVE: 'UNDO_MOVE',
    RESTART_GAME: 'RESTART_GAME',
};

// Initial state
export const initialState = {
    blocks: [],
    pieces: [],
    capturedPieces: [],
    selectedPiece: null,
    turn: 'white',
    ongoingChainCapture: false,
    result: null,
    moveHistory: [],
};

// Reducer function
export function gameReducer(state, action) {
    switch (action.type) {
        case ACTIONS.INITIALIZE_GAME:
            return {
                ...state,
                blocks: action.payload.blocks,
                pieces: action.payload.pieces,
            };
        case ACTIONS.SELECT_PIECE: {
            let newState = state;
            newState = clearHighlights(state)
            newState = selectPiece(newState, action.payload.x, action.payload.y)
            return newState
        }
        case ACTIONS.MOVE_PIECE: {

            const legalMove = validateMove(action.payload.selectedPiece, state.pieces, state.blocks, action.payload.x, action.payload.y)
            if (!legalMove) {
                console.log('Not a legal move');
                return state;
            }
            // Save current state BEFORE making changes
            const stateSnapshot = {
                blocks: state.blocks,
                pieces: state.pieces,
                capturedPieces: state.capturedPieces,
                selectedPiece: state.selectedPiece,
                turn: state.turn,
                ongoingChainCapture: state.ongoingChainCapture,
                result: state.result
                // Don't include moveHistory in the snapshot
            };

            let newState = state;
            newState = clearHighlights(newState);
            newState = movePiece(newState, action.payload.x, action.payload.y, action.payload.selectedPiece);
            newState = checkForWin(newState);
            newState = checkForPromotion(newState);
            newState = changeTurn(newState);
            newState = updateMoveHistory(newState, stateSnapshot);

            return newState
        }
        case ACTIONS.SET_RESULT:
            return {
                ...state,
                resul: action.payload,
            };
        case ACTIONS.UNDO_MOVE:
            // Don't allow undo during AI's turn
            if (state.turn === "black") {
                return state;
            }

            if (state.moveHistory.length === 0) {
                console.log('nothing to undo');
                return state;
            }

            const isAITurn = state.turn === "black";

            // Undo twice if it's the player's turn to move (player + ai move)
            const undoCount = isAITurn ? 1 : 2;

            if (state.moveHistory.length < undoCount) {
                console.log('not enough undo count');

                return state;
            }

            let previousState = state.moveHistory[state.moveHistory.length - undoCount];
            previousState = clearHighlights(previousState)

            return {
                ...previousState,
                moveHistory: state.moveHistory.slice(0, -undoCount)
            };
        case ACTIONS.RESTART_GAME:
            return {
                ...initialState,
                blocks: action.payload.blocks,
                pieces: action.payload.pieces,
            };

        default:
            return state;
    }
}